module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('b-field', [_c('p', {
    staticClass: "control"
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "href": "https://github.com/buefy/buefy",
      "target": "_blank"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "github-circle"
    }
  }), _vm._v(" "), _c('span', [_vm._v("GitHub")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('a', {
    staticClass: "button is-patreon",
    attrs: {
      "href": "https://www.patreon.com/jtommy",
      "target": "_blank"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "patreon"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Patreon")])], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('router-link', {
    staticClass: "navbar-item has-text-weight-semibold",
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, [_vm._v("\n                            Home\n                        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item has-text-weight-semibold",
    attrs: {
      "to": "/documentation"
    }
  }, [_vm._v("\n                            Documentation\n                        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item has-text-weight-semibold",
    attrs: {
      "to": "/extensions"
    }
  }, [_vm._v("\n                            Extensions\n                        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item has-text-weight-semibold",
    attrs: {
      "to": "/expo"
    }
  }, [_vm._v("\n                            Expo\n                        ")])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                            Maintained by\n                            "), _c('a', {
    attrs: {
      "href": "https://twitter.com/walter_tommasi",
      "target": "_blank"
    }
  }, [_vm._v("Walter Tommasi")]), _vm._v(".\n                            Authored by\n                            "), _c('a', {
    attrs: {
      "href": "https://twitter.com/rafaelpimpa",
      "target": "_blank"
    }
  }, [_vm._v("Rafael Beraldo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('small', [_vm._v("\n                                Buefy's source code is licensed under\n                                "), _c('a', {
    attrs: {
      "href": "http://opensource.org/licenses/mit-license.php",
      "target": "_blank"
    }
  }, [_vm._v("MIT")]), _vm._v(".\n                            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d4b3a7f"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/components/TheFooter.vue
// module id = 915
// module chunks = 0 2 300